export default "__VITE_ASSET__BiN1xfn7__"